import React, {FC, ReactNode, useRef} from 'react';
import ReactDOM from 'react-dom';
import {cn} from "../../lib/Utils";
import {Button} from "../ui/Button";
import {X} from "lucide-react";

interface BaseModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    overlayClassName?: string;
    containerClassName?: string;
}

export const BaseModal: FC<BaseModalProps> = ({
      isOpen,
      onClose,
      children,
      overlayClassName,
      containerClassName,
    }) => {

    if (!isOpen) {
        return null;
    }

    const modalRef = useRef<HTMLDivElement>(null);

    const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
            onClose();
        }
    };

    const defaultOverlayClasses = 'fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 ' +
        'backdrop-blur-md transition-opacity duration-150';
    const defaultContainerClasses = 'relative bg-surface-900 border border-surface-800 rounded-[18px] ' +
        'shadow-[0_36px_64px_-32px_rgba(0,0,0,.8)] overflow-hidden transition-all duration-200 ease-[cubic-bezier(.34,.07,.18,1)]';

    return ReactDOM.createPortal(
        <div
            onClick={handleOverlayClick}
            className={cn(defaultOverlayClasses, overlayClassName)}
        >
            <div
                ref={modalRef}
                className={cn(defaultContainerClasses, containerClassName)}
                role="dialog"
                aria-modal="true"
            >
                {children}
            </div>
        </div>,
        document.body
    );
};

export interface CloseButtonProps {
    onClose: () => void;
}

export const ModalCloseButton = (onClose : CloseButtonProps) => {
    return(
        <Button
            intent="icon"
            onClick={onClose.onClose}
            className="absolute top-2 right-2 hover:text-surface-100"
        >
            <X size={24}/>
        </Button>
    );
};













